import React, { useState } from 'react';
import styles from './Signin.module.css';
import { useTranslation } from 'react-i18next';
import { CustomButton, CustomInputText, CustomLink, CustomLoader, CustomTitle } from '../../components';
import { createAccount } from '../../services/authService';
import CustomSelectInput from '../../components/customSelectInput/CustomSelectInput';
import { userTypes } from '../../enums/userTypes.enum';

const Signin = () => {

    const { t } = useTranslation();

    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [userType, setUserType] = useState<string>(userTypes.DV);
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [helperText, setHelperText] = useState('');

    const formatedUserTypes : ListElementType[] = Object.values(userTypes).map((type, index) => {
        const item: ListElementType = {
            id: index,
            title: type,
            description: t(`usertypes.${type}`)
        };
        return item;
    });

    const [isSignSend, setIsSignSend] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const isFormComplete = () => {
        return (
            isPasswordSame() &&
            isPasswordOk() &&
            isEmailFormatOk() &&
            password !== "" &&
            email !== "" &&
            username !== ""
        )
    }

    const isPasswordOk = () => {
        return password === "" || password.length >= 6
    }

    const isPasswordSame = () => {
        return password === passwordConfirm
    }

    const isEmailFormatOk = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email) || email === '';
    }

    const signin = async () => {
        setIsLoading(true);

        const res = await createAccount(username, email, userType, password);

        if (!res?.error) {
            setIsSignSend(true);
        } else {
            setHelperText(t('signin.bad_username'));
        }
        
        setIsLoading(false);
    }

    return (
        <div className={ styles.container }>
            <div>
                <CustomTitle className={styles.title}>{t('signin.signin')}</CustomTitle>

                
                    <div className={styles.form}>
                        { !isSignSend &&
                            <>
                                <CustomInputText id="username" label={t('signin.username')} type="text" textValue={username} setTextValue={setUsername} helperText={helperText} error={helperText !== ''} required />
                                <CustomInputText id="email" error={!isEmailFormatOk()} label={t('signin.email')} type="email" textValue={email} setTextValue={setEmail} helperText={!isEmailFormatOk() ? t('signin.error_email') : ''} required />
                                <CustomSelectInput id="userType" label={t('signin.usertype')} value={userType} onChange={(value) => setUserType(value)} list={formatedUserTypes} />
                                <CustomInputText id="password" error={!isPasswordOk()} label={t('signin.password')} type="password" textValue={password} setTextValue={setPassword} helperText={!isPasswordOk() ? t('signin.error_password') : ''} required />
                                <CustomInputText id="passwordConfirm" error={!isPasswordSame()} label={t('signin.password_confirm')} type="password" textValue={passwordConfirm} setTextValue={setPasswordConfirm} helperText={!isPasswordSame() ? t('signin.error_password_confirm') : ''} required />

                                <div className={styles.sendBtn}>
                                    <CustomButton disabled={!isFormComplete()} onClick={() => { signin() }}>{ t('general.confirm') }</CustomButton>
                                    <span className={styles.haveAccountContainer}>{t('login.have_account')} <CustomLink to='/login' className={styles.haveAccount}>{t('login.have_account_login')}</CustomLink></span>
                                </div>
                            </>
                        }

                        { isSignSend &&
                            <div>
                                <p className={styles.isSigned}>{ t('signin.confirm_email') }</p>
                                <p className={styles.emailConfirm}>{ t('signin.signin_done') }</p>
                            </div>
                        }
                    </div>

                <CustomLoader isLoading={isLoading}/>
            </div>
        </div>
    )
}

export default Signin;